const purge = {
  annualPurge: "Purge annuelle",
  annualDataPurge: "Purge annuelle des données",
  purgeWarning:
    "La purge supprimera toutes les données de l'application relatives aux comptes personnels, classes, devoirs et établissements.",
  purgeIrreversible:
    "Cette action est irréversible et doit avoir lieu dans le cadre de la purge annuelle prévue par le GAR le 15 août.",
  purgeToConfirm:
    'Pour confirmer, veuillez saisir dans le champ suivant "Je confirme vouloir purger les données" ',
  launchPurge: "Lancer la purge",
};

export default purge;
